import { createContext, ReactNode, useContext, useState } from 'react';

interface DataContextType {
  data: any;
  setData: (data: any) => void;
}

export const DataContext = createContext<DataContextType | null>(null);

export const useDataContext = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useDataContext must be used within a DataProvider');
  }
  return context;
};

export const DataProvider = ({
  children,
  initialData,
}: {
  children: ReactNode;
  initialData?: any;
}) => {
  const [data, setData] = useState(initialData || {});

  return (
    <DataContext.Provider value={{ data, setData }}>
      {children}
    </DataContext.Provider>
  );
};
